import { render } from "./top-nav.vue?vue&type=template&id=45e5db25"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__